import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Drums() {
  return <ImageCollectionPage title="Drums" path="/culture/drums" collection="culture_drums" />;
}
